module.exports = __webpack_public_path__ + "img/chat.5fb39aed.svg";